import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild, inject, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { environment } from "../../../environments/environment";
import { JwTokenModel, UserModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { AccountApiService } from "../../core/api/services";
import { DOCUMENT } from '@angular/common';

declare let CBOR: any;

@Component({
  selector: 'app-profile-component',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  standalone: false
})
export class ProfileComponent implements OnInit, AfterViewInit {
  itemFormGroup!: FormGroup;
  loading: boolean = false;
  formError: string | undefined | null;


  returnUrl: string | undefined | null;
  user: UserModel | null = null;
  token: JwTokenModel | null = null;

  loadingPicture: boolean = false;

  // jwToken: any | null = null;


  showRegister2factor: boolean = false;
  accountApiService = inject(AccountApiService);
  OneTimePassword: string = "";

  OneTimePasswordUri: string | undefined | null;
  OneTimePasswordConfirm: string = "";
  OneTimePasswordKey: string | undefined | null;
  WebAuthnkey: string | undefined | null;
  WebAuthnkeyInfo: string = "";


  //passwordExpired: boolean = false;
  showChangePassword: boolean = false;
  newPassword: string = "";
  newPasswordConfirm: string = "";
  updateClientsPassword: boolean = true;

  document = inject(DOCUMENT);
  

  constructor(private authService: AuthService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone,
    private http: HttpClient,
    private alertService: AlertService,
    private renderer: Renderer2,
  ) {
  }


  ngOnInit(): void {

    console.debug('ProfileComponent.ngOnInit');


    this.itemFormGroup = this.formBuilder.group(
      {
        UserName: ['', [Validators.required, Validators.maxLength(50)]],

        FirstName: ['', [Validators.maxLength(255)]],
        LastName: ['', [Validators.maxLength(255)]],
        Email: ['', [Validators.maxLength(255), Validators.email, Validators.required]],
        PhoneNumber: ['', [Validators.maxLength(25)]],

        GitHub_Username: ['', [Validators.maxLength(25)]],
        GitHub_AccessToken: ['', [Validators.maxLength(1000)]],
        Teamcity_AccessToken: ['', [Validators.maxLength(255)]],
        ValidIPAddresses: ['', [Validators.maxLength(1000)]],

        NotificationOnNewSupportTicket: [false, []],

      });

    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];

      if (this.returnUrl)
        console.debug('URL returnUrl', this.returnUrl);
    });

    this.authService.getUserInfo().forEach(x => {
      this.user = x;
      this.load();
      if (!this.token?.refresh_token) {
        if (this.user?.WebAuthnCredentialId)
          this.verifyWebAuthn();
        else if (!this.user?.HasOneTimePasswordKey)
          this.generateKeys();
      }
      else if (this.user?.PasswordExpireDate != null
        && new Date(this.user.PasswordExpireDate) < new Date()) {
        //this.passwordExpired = true;
        this.showChangePassword = true;
      }
    });
    this.token = this.authService.tokenInfo;
    this.authService.tokenInfo$.forEach(x => {
      this.token = x;
      //this.jwToken = Utils.parseJwt(this.token?.access_token || '');
    });


    
    
  
  }

  ngAfterViewInit(): void {
    

    console.debug('ProfileComponent.AfterViewInit');
    
    
  }

  get passwordExpired() {
    return this.user?.PasswordExpireDate != null && new Date(this.user.PasswordExpireDate) < new Date();
  }

  load() {


   // if (this.itemFormGroup)
 //     this.itemFormGroup.resetForm();
    this.itemFormGroup.clearValidators();


    this.itemFormGroup.patchValue({
      UserName: this.user?.UserName,
      Email: this.user?.Email,
      PhoneNumber: this.user?.PhoneNumber,

      FirstName: this.user?.FirstName,
      LastName: this.user?.LastName,
      GitHub_Username: this.user?.GitHub_Username,
      GitHub_AccessToken: this.user?.GitHub_AccessToken,
      Teamcity_AccessToken: this.user?.Teamcity_AccessToken,
      ValidIPAddresses: this.user?.ValidIPAddresses,
      NotificationOnNewSupportTicket: this.user?.NotificationOnNewSupportTicket || false
    });
  }

  public myFormSubmit(_: any) {



    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();


    let model =
      {
        ...this.user,
        ...formValue
      } as UserModel;

    console.info(model);

    //const password = this.itemFormGroup.get('password')?.value;

    this.loading = true;
    this.accountApiService.Update({ body: model })
      .forEach(
        user => {
          this.user = user;
          this.load();
          this.loading = false;

        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loading = false;
          }).
      finally(() => {
      });

  }

  profileInitials() {
    if (!this.user)
      return null;
    if (this.user?.FirstName && this.user?.FirstName.length > 0
      && this.user?.LastName && this.user?.LastName.length > 0)
      return (this.user?.FirstName[0] + this.user?.LastName[0]).toUpperCase();

    var temp = this.user?.FirstName || this.user?.UserName;
    if (temp && temp.length > 1)
      return temp[0].toUpperCase();
    return null;
  }

  uploadPicture(fileInput: any) {
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      this.loadingPicture = true;
      this.accountApiService.UpdateProfileImage({
        body: {
          file: fileInput.files[0]
        }
      }).forEach(
        (user) => {
          this.alertService.info('Profile picture updated successfully');
          this.user = user;
          this.authService.userInfo$.next(user);
          this.load();
          this.loading = false;


        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loading = false;
          }).
        finally(() => {
          this.loadingPicture = false;
        });
    }
  }


  verifyWebAuthn() {

    if (!this.user?.WebAuthnCredentialId) {
      this.alertService.error('No WebAuthn credential found');
      return;
    }
    try {
      /// generate 32 char random string as challenge
      const challenge = window.crypto.getRandomValues(new Uint8Array(32));

      var publicKeyCredentialRequestOptions = {
        challenge: challenge,
        allowCredentials: [],
        rpId: location.hostname,
        userVerification: "required", // 'none', required', //preferred
        timeout: 60000,
        extensions: {
          //"appid": "https://localhost:44354",
          //'credProps': true
        }
      } as PublicKeyCredentialRequestOptions;

      var encoder = new TextEncoder();
      if (this.user?.WebAuthnCredentialId) {

        if (publicKeyCredentialRequestOptions.allowCredentials)
          publicKeyCredentialRequestOptions.allowCredentials.push({
            id: this.FromBase64ToBinaryArray(this.user.WebAuthnCredentialId),

            type: 'public-key',
            // transports: ['usb', 'ble', 'nfc', 'hybrid', 'internal']
            transports: ['internal'],
          });
      }

      console.log(publicKeyCredentialRequestOptions);

      navigator.credentials.get({
        publicKey: publicKeyCredentialRequestOptions
      })
        .then((credential) => {

          console.log(credential);
          //console.log(FromArrayBufferToBase64(cred.rawId));
          let cred = credential as PublicKeyCredential;
          if (!cred) {

            this.alertService.info('Invalid credentials');
            return;
          }
          let response = cred.response as AuthenticatorAssertionResponse;
          var authKeyData = {
            credentialId: this.FromArrayBufferToBase64(cred.rawId),
            authenticatorData: this.FromArrayBufferToBase64(response.authenticatorData),
            clientDataJSON: this.FromArrayBufferToBase64(response.clientDataJSON),
            signature: this.FromArrayBufferToBase64(response.signature),
            userHandle: this.FromArrayBufferToBase64(response.userHandle || new ArrayBuffer(0))
          };

          let WebAuthnVerfiy = JSON.stringify(authKeyData);
          
          //let decoder = new TextDecoder("utf-8");
          //var userid = decoder.decode(this.FromBase64ToBinaryArray(authKeyData.userHandle));
          // $('#txtWebAuthnLoaded').val(userid + ' - ' + authKeyData.credentialId);
          


          this.loading = true;
          this.accountApiService.VerifyTwoFactor({ body: { oneTimePassword: undefined, webAuthnVerify: WebAuthnVerfiy } })
            .forEach(
              token => {
                this.authService.tokenInfo$.next(token);
                this.token = token
                this.authService.getUserInfo().subscribe(x => {
                  this.user = x;
                  this.authService.redirectAfterLogin(x, this.returnUrl);
                });
                this.loading = false;

              }).catch(
                err => {
                  this.alertService.error(Utils.getAjaxError(err));
                  this.loading = false;
                }).
            finally(() => {
            });;

        })
        .catch((err) => {

          console.log(err);
          if (err.name == 'NotAllowedError') {
            //this.alertService.error('Web Auth error: ' + err);
          }
          else {
            this.alertService.error('Web Auth error: ' + err);
          }
          
        });
    }
    catch (ex) {
      console.error(ex);
      this.alertService.error('Web Auth exception: ' + ex);
    }


  }
  verifyOneTimePassword() {
    this.loading = true;
    this.accountApiService.VerifyTwoFactor({ body: { oneTimePassword: this.OneTimePassword, webAuthnVerify: undefined } })
      .forEach(
        token => {
          this.authService.tokenInfo$.next(token);
          this.token = token
          this.authService.getUserInfo().subscribe(x => {
            this.user = x;
            this.authService.redirectAfterLogin(x, this.returnUrl);
          });
          this.loading = false;

        }).catch(
          err => {
            this.alertService.error(err.Message || 'Invalid credentials');
            this.loading = false;
          }).
      finally(() => {
      });      ;
    
  }

  sendCodePerSMS() {
    this.loading = true;
    this.accountApiService.SendOneTimePassword().forEach(x => {
      this.loading = false;
      this.alertService.info('Code Sent');
    }).catch(
      err => {
        this.alertService.error(err.Message || 'SMS not sent');
        this.loading = false;
      }).
      finally(() => {
      });
  }
  renewToken() {

    if (!this.token?.refresh_token) {
      this.alertService.error('You token is not valid');
      return;
    }
    this.loading = true;
    this.authService.getTokenInfo().forEach(token => {
      this.token = token
      this.loading = false;
    }).catch(
      err => {
        this.alertService.error(err.Message || 'Error getting new access token');
        this.loading = false;
      }).
      finally(() => {
      });
  }
  reset2Factor() {
    this.showRegister2factor = true;
    this.generateKeys();
    
  }

  generateKeys() {

    this.OneTimePasswordUri = null;
    this.OneTimePasswordKey = null;

    this.WebAuthnkey = null;
    this.WebAuthnkeyInfo = 'Initializing';

    this.loading = true;
    this.registerWebAuthn();
    this.accountApiService.GenerateTwoFactorKey().forEach(qrKey => {
      this.OneTimePasswordUri = qrKey.CodeUri;
      this.OneTimePasswordKey = qrKey.SharedKey;
      this.loading = false;
    }).catch(
      err => {
        this.alertService.error(err.Message || 'Error getting new access token');
        this.loading = false;
      }).
      finally(() => {
      });
  }



  registerKeys() {

    if (!this.OneTimePasswordConfirm || this.OneTimePasswordConfirm.length < 6) {
      this.alertService.error('Invalid one time password');
      return;
    }

    this.loading = true;
    this.accountApiService.RegisterTwoFactor({ body: { oneTimePassword: this.OneTimePasswordConfirm, sharedKey: this.OneTimePasswordKey ?? undefined, webAuthnKey: this.WebAuthnkey ?? undefined } }).forEach(token => {
      this.authService.tokenInfo$.next(token);
      this.token = token
      this.authService.getUserInfo().subscribe(x => {
        this.loading = false;
        this.user = x;
        if (!this.showRegister2factor)
          this.authService.redirectAfterLogin(x, this.returnUrl);
      });
      this.showRegister2factor = false;
    }).catch(
      err => {
        this.alertService.error(err.Message || 'Error Register Two Factor');
        this.loading = false;
      }).
      finally(() => {
      });


    
  }
  registerWebAuthn() {

    const scriptElement = this.renderer.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = 'https://cdn.jsdelivr.net/npm/cbor-js@0.1.0/cbor.min.js';
    this.renderer.appendChild(this.document.body, scriptElement);
    scriptElement.onerror = () => {
      console.error('Could not load CBOR');
      this.alertService.error('Could not load CBOR library');
    }
    scriptElement.onload = () => {



      try {

        let challengeKey = this.OneTimePasswordKey || "ABCDE12346ABCDE12346ABCDE12346ABCDE12346";


        const createCredentialDefaultArgs = {
          publicKey: {

            challenge: Uint8Array.from(challengeKey, c => c.charCodeAt(0)),

            rp: {
              name: 'ArkMed Management',
              id: location.hostname
            },

            // User:
            user: {
              id: Uint8Array.from("ARK_" + this.user?.ID, c => c.charCodeAt(0)),
              name: this.user?.UserName,
              displayName: `${this.user?.FirstName} ${this.user?.LastName}`,
            },

            pubKeyCredParams: [
              // https://www.iana.org/assignments/cose/cose.xhtml#algorithms

              {
                alg: -39, // PS512	    RSASSA-PSS w/ SHA-512
                type: "public-key"
              },
              {
                alg: -38, // RS384   	RSASSA-PSS w/ SHA-384
                type: "public-key"
              },

              {
                alg: -257, // RS256     RSASSA-PKCS1-v1_5 w/ SHA-256
                type: "public-key"
              },

              {
                alg: -44, // SHA-512   SHA-2 512-bit Hash
                type: "public-key"
              },
              {
                alg: -43, // SHA-384   SHA-2 384-bit Hash
                type: "public-key"
              },
              {
                alg: -41, // RSAES-OAEP w/ SHA-256   RSAES-OAEP w/ SHA-256
                type: "public-key"
              },

              {
                type: "public-key",
                alg: -7, // ECDSA w/ SHA-256 , accepts Elliptic Curve public keys using a SHA-256 signature algorithm
              },
              {
                alg: -8,  // EdDSA
                type: "public-key"
              }
            ],
            authenticatorSelection: {
              userVerification: "required", // "required"
              authenticatorAttachment: "platform" // platform authenticator
              // requireResidentKey: false //  if the created credential should be available for future account picker UX.
            },
            attestation: "none", //"direct",

            timeout: 60000, // The time (in milliseconds) that the user has to respond to a prompt for registration before an error is returned.

            excludeCredentials: [],
            /*
            excludeCredentials: [
                // Don’t re-register any authenticator that has one of these credentials
                { "id": Uint8Array.from(window.atob("ufJWp8YGlibm1Kd9XQBWN1WAw2jy5In2Xhon9HAqcXE="), c => c.charCodeAt(0)), "type": "public-key" },
                { "id": Uint8Array.from(window.atob("E/e1dhZc++mIsz4f9hb6NifAzJpF1V4mEtRlIPBiWdY="), c => c.charCodeAt(0)), "type": "public-key" }
            ],
   
            // Make excludeCredentials check backwards compatible with credentials registered with U2F
            extensions: { "appidExclude": "https://acme.example.com" }
            */
            extensions: {
              //'credProps': true
            }
          },
        } as CredentialCreationOptions;



        console.log(createCredentialDefaultArgs);


        // register / create a new credential
        navigator.credentials
          .create(createCredentialDefaultArgs)
          .then((credentialAny) => {

            console.log("NEW CREDENTIAL", credentialAny);
            let credential = credentialAny as PublicKeyCredential;

            if (!credential) {

              this.WebAuthnkeyInfo = 'Failed';
              this.alertService.error('Error getting webAuth credential');
              return;
            }


            //document.getElementById("txtWebAuthnKey").value = credential;

            const utf8Decoder = new TextDecoder('utf-8');
            const decodedClientData = utf8Decoder.decode(credential.response.clientDataJSON)

            // parse the string as an object
            const clientDataObj = JSON.parse(decodedClientData);
            //console.log(clientDataObj)

            let attestationResponse = credential.response as AuthenticatorAttestationResponse;

            //const cbor = require('cbor');
            const decodedAttestationObject = CBOR.decode(attestationResponse.attestationObject);

            //console.log(decodedAttestationObject);

            const { authData } = decodedAttestationObject as any;

            // get the length of the credential ID
            const dataView = new DataView(new ArrayBuffer(2));
            const idLenBytes = authData.slice(53, 55);
            // @ts-ignore
            idLenBytes.forEach((value, index) => dataView.setUint8(index, value));
            // @ts-ignore
            const credentialIdLength = dataView.getUint16();


            // get the credential ID
            const credentialId = authData.slice(55, 55 + credentialIdLength);

            // get the public key object
            const publicKeyBytes = authData.slice(55 + credentialIdLength);

            // the publicKeyBytes are encoded again as CBOR
            const publicKeyObject = CBOR.decode(publicKeyBytes.buffer);


            // console.log(credential.id);
            //  console.log(FromArrayBufferToBase64(credential.rawId));
            console.log(this.FromArrayBufferToBase64(credentialId));
            //console.log(publicKeyObject);

            var publicKeyData =
              {

                CredentialId: this.FromArrayBufferToBase64(credentialId),


                KeyType: publicKeyObject['1'] == 1 ? 'OKP' :// Octet Key Pair
                  publicKeyObject['1'] == 2 ? 'EC2' : //Elliptic Curve Keys w/ x- and y-coordinate pair
                    publicKeyObject['1'] == 3 ? 'RSA' : //RSA Key
                      publicKeyObject['1'] == 4 ? 'Symmetric' : //Symmetric Key
                        publicKeyObject['1'] == 5 ? 'HSS-LMS' : // Public key for HSS/LMS hash-based digital signature	
                          publicKeyObject['1'] == 6 ? 'WalnutDSA' : //WalnutDSA public key
                            publicKeyObject['1'],

                KeyId: publicKeyObject['2'],

                Algorithm:
                  publicKeyObject['3'] == -65535 ? 'RS1' :
                    publicKeyObject['3'] == -259 ? 'RS512' :
                      publicKeyObject['3'] == -258 ? 'RS384' :
                        publicKeyObject['3'] == -257 ? 'RS256' :
                          publicKeyObject['3'] == -39 ? 'PS512' :
                            publicKeyObject['3'] == -38 ? 'PS384' :
                              publicKeyObject['3'] == -37 ? 'PS256' :
                                publicKeyObject['3'] == -36 ? 'ES512' :
                                  publicKeyObject['3'] == -35 ? 'ES384' :
                                    publicKeyObject['3'] == -8 ? 'EdDSA' :
                                      publicKeyObject['3'] == -7 ? 'ES256' :
                                        publicKeyObject['3'] == -47 ? 'ES256K' :

                                          publicKeyObject['3'] == -43 ? 'SHA-384' :
                                            publicKeyObject['3'] == -44 ? 'SHA-512' :
                                              publicKeyObject['3'] == -41 ? 'RSAES-OAEP w/ SHA-256' :
                                                publicKeyObject['3'] == -46 ? 'HSS-LMS' :


                                                  publicKeyObject['3'],

                KeyOps: publicKeyObject['4'],

                BaseIV: publicKeyObject['5']
              } as any;
            try {
              if (publicKeyData.KeyType == 'RSA') {
                if (publicKeyObject['-1'] != undefined) {
                  publicKeyData['N'] = this.FromArrayBufferToBase64(publicKeyObject['-1']);
                  delete publicKeyObject['-1'];
                }
                if (publicKeyObject['-2'] != undefined) {
                  publicKeyData['E'] = this.FromArrayBufferToBase64(publicKeyObject['-2']);
                  delete publicKeyObject['-2'];
                }
              }
              else if (publicKeyData.KeyType == 'EC2'
                || publicKeyData.KeyType == 'OKP') {


                if (publicKeyObject['-1'] != undefined) {
                  publicKeyData['Curve'] =
                    publicKeyObject['-1'] == 1 ? 'P256' :
                      publicKeyObject['-1'] == 2 ? 'P384' :
                        publicKeyObject['-1'] == 3 ? 'P521' :
                          publicKeyObject['-1'] == 4 ? 'X25519' :
                            publicKeyObject['-1'] == 5 ? 'X448' :
                              publicKeyObject['-1'] == 6 ? 'Ed25519' :
                                publicKeyObject['-1'] == 7 ? 'Ed448' :
                                  publicKeyObject['-1'] == 8 ? 'P256K' :
                                    publicKeyObject['-1'];
                  delete publicKeyObject['-1'];
                }
                if (publicKeyObject['-2'] != undefined) {
                  publicKeyData['X'] = this.FromArrayBufferToBase64(publicKeyObject['-2']);
                  delete publicKeyObject['-2'];
                }
                if (publicKeyObject['-3'] != undefined) {
                  publicKeyData['Y'] = this.FromArrayBufferToBase64(publicKeyObject['-3']);
                  delete publicKeyObject['-3'];
                }
              }
              else {
                if (publicKeyObject['-1'] != undefined) {
                  publicKeyData['Key'] = this.FromArrayBufferToBase64(publicKeyObject['-1']);
                  delete publicKeyObject['-1'];
                }
              }
            } catch (ex) {

            }

            for (var k in publicKeyObject) {
              if (k == '1' || k == '2' || k == '3' || k == '4' || k == '5')
                continue;
              if (publicKeyObject[k] == null || publicKeyObject[k] == '')
                continue;
              publicKeyData[k] = publicKeyObject[k];
            }

            publicKeyData = this.removeEmpty(publicKeyData);

            console.log(publicKeyData);


            this.WebAuthnkey = JSON.stringify(publicKeyData);
            this.WebAuthnkeyInfo = publicKeyData.KeyType + ' - ' + publicKeyData.Algorithm + ' - ' + publicKeyData.CredentialId;


          })
          .catch((err) => {
            console.log("ERROR", err);
            // "The user attempted to register an authenticator that contains one of the credentials already registered with the relying party."
            // name "InvalidStateError"
            if (err.name == "InvalidStateError" || (err.message && err.message.indexOf("credentials already registered") > 0)) {
              this.alertService.error('This device is already registered');
              this.WebAuthnkeyInfo = 'This device is already registered';
            }
            else if (err.name == 'NotAllowedError') {
              //this.alertService.error('Web Auth error: ' + err);
              this.WebAuthnkeyInfo = 'This device does not support Web Auth (Pass Key) authetication';
            }
            else {
              this.alertService.error(err.message ?? err);
              this.WebAuthnkeyInfo = 'Error: ' + (err.message ?? err);
            }
          });

      }
      catch (ex) {
        console.error(ex);
      }
      return false;

    }
  }

  FromBase64ToBinaryArray(base64_string: string) {
    //console.debug(base64_string);
    var binary_string = window.atob(base64_string);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++)
      bytes[i] = binary_string.charCodeAt(i);
    return bytes.buffer;
  }
  FromArrayBufferToBase64(buffer: ArrayBuffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);

  }

  removeEmpty(obj: any) {
    try {
      for (var i in obj) {
        try {
          if (obj[i] == null || obj[i] == '')
            delete obj[i];
        }
        catch (Ex2) {
        }
      }
    }
    catch (Ex) {
    }
    return obj;
  }


  changePaword() {
    this.showChangePassword = true;
  }

  updatePaword(_: any) {

    if (!this.newPassword || this.newPassword.length < 10) {
      this.alertService.error('Invalid new password');
      return;
    }
    if (!this.newPasswordConfirm || this.newPassword != this.newPasswordConfirm) {
      this.alertService.error('Invalid confirm password');
      return;
    }

    this.loading = true;
    const wasPasswordExpired = this.passwordExpired;
    this.accountApiService.UpdatePassword({ body: { password: this.newPassword, updateClientsPassword: this.updateClientsPassword } }).forEach(token => {
      this.authService.tokenInfo$.next(token);
      this.token = token
      this.authService.getUserInfo().subscribe(x => {
        this.loading = false;
        this.user = x;
        if (wasPasswordExpired)
          this.authService.redirectAfterLogin(x, this.returnUrl);
      });
      this.showChangePassword = false;
    }).catch(
      err => {
        this.alertService.error(err.Message || 'Error Update Password');
        this.loading = false;
      }).
      finally(() => {
      });



  }

}
